import React from "react";
import { useApp } from "@/context/AppContext";
import { Progress } from "@/components/ui/progress";
import { Sparkles } from "lucide-react";

export const QuotaIndicator = ({ compact = false }) => {
  const { quota, t } = useApp();
  if (!quota) return null;
  const unlimited = quota.limit === null;
  const pct = unlimited ? 100 : Math.min(100, Math.round((quota.used / quota.limit) * 100));
  return (
    <div data-testid="usage-quota-indicator" className={compact ? "w-full" : "w-full max-w-xs"}>
      <div className="flex items-center justify-between text-xs mb-1.5">
        <span className="flex items-center gap-1.5 text-muted-foreground">
          <Sparkles className="h-3.5 w-3.5" /> {t("usageQuota")}
        </span>
        <span className="font-mono font-medium">
          {unlimited ? `${quota.used} \u2022 ${t("unlimited")}` : `${quota.used} / ${quota.limit}`}
        </span>
      </div>
      <Progress value={unlimited ? 8 : pct} className="h-1.5" />
    </div>
  );
};
